import { defineMessages } from 'react-intl';

export default defineMessages({
  advancedAnalytics: {
    description: 'Title for Advanced Analytics license display',
    defaultMessage: 'Advanced Analytics',
    id: 'hnh3Os',
  },
  analyticsDescriptionViewOnly: {
    description: 'Description for the view only version of analytics',
    defaultMessage:
      'Includes view-only access for up to {licenseLimit} existing users. These are licenses you can assign and do not increase your total user count.',
    id: 'ftWohW',
  },
  analyticsDescriptionExplore: {
    description: 'Description for the explore version of analytics',
    defaultMessage:
      'Includes edit access to customize your data for up to {licenseLimit} users. These are licenses you can assign and do not increase your total user count.',
    id: '3OJDij',
  },
  licensesInUse: {
    description: 'Label for analytics license count in use',
    defaultMessage: 'Licenses in use',
    id: '1MHkCi',
  },
  licensesInUseBy: {
    description: 'Tooltip showing which users have analytics licenses assigned',
    defaultMessage: 'Licenses are currently in use by: {userNames}',
    id: 'lRurYF',
  },
  addLicenses: {
    description: 'Button text to add more analytics licenses',
    defaultMessage: 'Add Licenses',
    id: 'X5pLAS',
  },
});
